import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
} from 'firebase/firestore';
import { db } from '../../../firebase';

const getSessionsCollection = (uid) => collection(db, 'users', uid, 'sessions');

export const subscribeToSessions = (uid, callback) => {
  const sessionsQuery = query(getSessionsCollection(uid), orderBy('timestamp', 'desc'));
  return onSnapshot(
    sessionsQuery,
    (snapshot) => {
      const sessions = snapshot.docs.map((sessionDoc) => ({
        id: sessionDoc.id,
        ...sessionDoc.data(),
      }));
      callback(sessions);
    },
    (error) => {
      console.error('Failed to subscribe sessions:', error);
      callback([]);
    }
  );
};

export const addSessionForUser = async (uid, sessionData) => {
  await addDoc(getSessionsCollection(uid), sessionData);
};

export const deleteSessionForUser = async (uid, sessionId) => {
  await deleteDoc(doc(db, 'users', uid, 'sessions', sessionId));
};
